import { render, staticRenderFns } from "./CustomerRightRail.vue?vue&type=template&id=bf2bfd32&scoped=true&"
import script from "./CustomerRightRail.vue?vue&type=script&lang=js&"
export * from "./CustomerRightRail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRightRail.vue?vue&type=style&index=0&id=bf2bfd32&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2bfd32",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VContainer,VIcon,VSheet,VTooltip})
